import { db, auth } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const isDev = process.env.NODE_ENV !== 'production';
const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';

/**
 * Log an error. In development, writes to the console.
 * In production, writes to the Firestore `errors` collection.
 *
 * @param {Error|string} error - The error object or message.
 * @param {object} [context] - Extra context: { page, ...any }.
 */
export async function logError(error, context = {}) {
  const message =
    (error && error.message) || (typeof error === 'string' ? error : 'Unknown error');
  const stack = (error && error.stack) || null;
  const page = context.page || (typeof window !== 'undefined' ? window.location.pathname : 'unknown');

  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(`[logger] ${page}: ${message}`, error, context);
    return;
  }

  try {
    await addDoc(collection(db, 'errors'), {
      message,
      stack,
      userId: auth.currentUser ? auth.currentUser.uid : null,
      page,
      appVersion: APP_VERSION,
      timestamp: serverTimestamp(),
      ...context,
    });
  } catch (loggingError) {
    // Never let the logger itself break the app. Fall back to console so the
    // error is at least visible in the browser devtools if anyone is watching.
    // eslint-disable-next-line no-console
    console.error('[logger] Failed to write error to Firestore:', loggingError);
    // eslint-disable-next-line no-console
    console.error('[logger] Original error:', error);
  }
}

/**
 * Log an informational message. Console-only; never written to Firestore.
 */
function logInfo(...args) {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log('[logger]', ...args);
  }
}

const logger = { error: logError, info: logInfo };
export default logger;
